import React from "react";
import { Skeleton } from "components";
import { Col, Row } from "react-bootstrap";

export default function UserCardSkeleton() {
  return (
    <Row className="align-items-center p-0 m-0">
      <Col xs={5} className="p-0">
        <Skeleton count={1} height={50} width={50} circle />
      </Col>
      <Col xs={7} className="p-0">
        <Skeleton count={1} height={10} width={"100%"} />
      </Col>
    </Row>
  );
}
